import { render } from "./index.vue?vue&type=template&id=198db6da&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=198db6da&lang=less"
import "./index.vue?vue&type=style&index=1&id=198db6da&lang=less"

import exportComponent from "/data/gitlab/pay.klicklpay.com/KlicklPaymentPage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__